import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";

export default function ConfirmButton({
    component: ButtonComponent = Button,
    dialogTitle,
    dialogContent,
    confirmButtonProps,
    cancelButtonProps,
    onClick,
    children,
    ...restProps
}) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <ButtonComponent onClick={() => setOpen(true)} {...restProps}>
                {children}
            </ButtonComponent>

            <Dialog open={open}>
                <DialogTitle>{dialogTitle}</DialogTitle>
                <DialogContent>{dialogContent}</DialogContent>
                <DialogActions>
                    <Button {...cancelButtonProps} onClick={() => setOpen(false)}>
                        ยกเลิก
                    </Button>
                    <Button variant="contained" color="error" {...confirmButtonProps} onClick={onClick}>
                        ยืนยัน
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
